/**
 * PhoneNav — the phone's navigation: the nav rail's list filling the screen
 * while no panel is open. Picking an entry opens its panel over the whole
 * screen, and closing the last panel comes back here.
 */

import type { ComponentProps, ReactElement } from 'react';
import React from 'react';

import { OccurraMark } from '@/components/occurra/OccurraMark';
import { cn } from '@/lib/utils';

import { NavRail } from './NavRail';

type Props = Omit<ComponentProps<typeof NavRail>, 'fullScreen' | 'reserveLogoSpace'>;

export const PhoneNav = (props: Props): ReactElement => (
    <div className={cn(
        'absolute inset-0 z-10 flex flex-col bg-occ-background-panel',
        'pb-[env(safe-area-inset-bottom)] pt-[env(safe-area-inset-top)]',
    )}
    >
        <div className="flex shrink-0 items-center gap-2 px-4 pt-4">
            <OccurraMark className="size-9 shrink-0" />
            <span className="text-sm font-semibold tracking-[0.2em] text-occ-brand">OCCURRA</span>
        </div>
        <NavRail
            {...props}
            fullScreen
            reserveLogoSpace={false}
        />
    </div>
);
